import React, { FunctionComponent, PropsWithChildren } from 'react';
import { ContentSection, Fieldset } from '@vwfs-bronson/bronson-react';

export const DashboardWrapper: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return (
    <ContentSection className="u-ph-large">
      <Fieldset>{children}</Fieldset>
    </ContentSection>
  );
};
